import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CheckCircle2, Download, Gift } from 'lucide-react';
import { motion } from 'framer-motion';
export function EbookSection() {
  return <Section background="green" className="text-white relative overflow-hidden" data-id="element-50">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl" data-id="element-51"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#D4AF37]/10 rounded-full blur-3xl" data-id="element-52"></div>

      <div className="relative z-10 grid md:grid-cols-2 gap-12 items-center" data-id="element-53">
        {/* E-book Cover Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="relative" data-id="element-54">
          <div className="relative mx-auto max-w-sm" data-id="element-55">
            {/* Book shadow */}
            <div className="absolute inset-0 bg-[#D4AF37]/20 blur-2xl translate-y-8" data-id="element-56"></div>

            {/* Book cover with actual image */}
            <div className="relative" data-id="element-57">
              <img src="https://cdn.magicpatterns.com/uploads/eM4BtE6aCHFcTtYXPAa1nw/LymphoriaX_(7).png" alt="Guía Detox Natural - 7 Secretos" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-58" />
            </div>

            {/* Free badge */}
            <div className="absolute -top-4 -right-4 bg-red-500 text-white w-20 h-20 rounded-full flex items-center justify-center shadow-xl rotate-12 z-20" data-id="element-59">
              <div className="text-center" data-id="element-60">
                <p className="text-xs font-bold uppercase" data-id="element-61">Gratis</p>
                <p className="text-lg font-black" data-id="element-62">100%</p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Content */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} viewport={{
        once: true
      }} data-id="element-63">
          <div className="inline-flex items-center gap-2 bg-[#D4AF37] text-white px-4 py-2 rounded-full text-sm font-bold mb-6" data-id="element-64">
            <Gift className="w-4 h-4" data-id="element-65" />
            Regalo Exclusivo por Tiempo Limitado
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-66">
            E-book GRATIS: Guía Detox Natural
          </h2>

          <p className="text-green-100 text-lg mb-8 leading-relaxed" data-id="element-67">
            Potencia los efectos de StingFit con nuestra guía exclusiva de
            desintoxicación natural. Aprende a eliminar toxinas, reducir la
            retención de líquidos y acelerar tu metabolismo de forma natural.
          </p>

          <div className="space-y-4 mb-8" data-id="element-68">
            {['Plan de alimentación anti-inflamatoria de 7 días', 'Recetas detox fáciles y deliciosas', 'Ejercicios de drenaje linfático en casa', 'Técnicas de hidratación para eliminar toxinas', 'Rutinas de sueño para optimizar resultados'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-69">
                <CheckCircle2 className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-70" />
                <span className="text-green-50" data-id="element-71">{item}</span>
              </div>)}
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20" data-id="element-72">
            <p className="text-sm text-green-100 mb-4" data-id="element-73">
              <span className="font-bold text-white" data-id="element-74">Valor: 29.95 €</span> •
              Tuyo GRATIS con cualquier pack de StingFit
            </p>
            <Button variant="primary" size="lg" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="group" data-id="element-75">
              <Download className="w-5 h-5 mr-2 group-hover:translate-y-1 transition-transform" data-id="element-76" />
              Sí, Quiero Mi E-book Gratis
            </Button>
          </div>
        </motion.div>
      </div>
    </Section>;
}